export default {
    stickers: {
        title: 'Autocolantes',
        stickerOpacity: 'Opacidade dos autocolantes',
        stickerColor: 'Cor do autocolante',
        shapes: {
            title: 'Formas',
            rectangle: 'Retângulo',
            circle: 'Círculo',
            triangle: 'Triângulo',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
